/* Black Deer — Ürün kartı ortak davranışları | bd-kart.js
   Favori ve sepete ekleme. Kartın render edildiği her bölümde geçerlidir;
   bölüm dosyalarına ayrıca script yazılmamalıdır.

   FAVORİLER: tek doğruluk kaynağı window.BDFav (bd-fav-store).
   Doğrudan localStorage'a yazmayın — merkezi sistem {h, v} biçimini kullanır,
   düz handle yazılırsa aynı ürün mükerrer kaydedilir ve kalp yanlış görünür. */
(function(){
  function favBagla(b){
    if(b.dataset.bdkHazir) return;
    b.dataset.bdkHazir = '1';
    var h = b.getAttribute('data-bd-fav');
    function boya(){
      var ekli = window.BDFav ? window.BDFav.var_mi(h) : false;
      b.setAttribute('aria-pressed', ekli ? 'true' : 'false');
      b.setAttribute('aria-label', ekli ? 'Favorilerimden \u00e7\u0131kar' : 'Favorilere ekle');
    }
    boya();
    b.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      if(!window.BDFav) return;
      // Karttan eklemede varyant bilinmez; müşteri ürün sayfasında beden seçip
      // kalbe basarsa kayıt bedenle güncellenir.
      window.BDFav.degistir(h, null);
      boya();
    });
    document.addEventListener('bd:fav', boya);
  }

  function ekleBagla(b){
    if(b.dataset.bdkHazir) return;
    b.dataset.bdkHazir = '1';
    b.addEventListener('click', function(e){
      e.preventDefault();
      if(!window.fetch) return;
      var eski = b.innerHTML;
      b.innerHTML = '<span>Ekleniyor\u2026</span>';
      b.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: b.getAttribute('data-bdk-ekle'), quantity: 1 })
      })
      .then(function(r){ return r.ok ? r.json() : Promise.reject(); })
      .then(function(){
        b.innerHTML = '<span>Sepete eklendi</span>';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function(){ b.innerHTML = eski; b.disabled = false; }, 1600);
      })
      .catch(function(){ b.innerHTML = eski; b.disabled = false; });
    });
  }

  function tara(){
    document.querySelectorAll('.bdk__fav[data-bd-fav]').forEach(favBagla);
    document.querySelectorAll('[data-bdk-ekle]').forEach(ekleBagla);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tara);
  else tara();
  // Filtre/sayfalama sonrası gelen kartlar için
  document.addEventListener('shopify:section:load', tara);
})();
